import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationPreQualification($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          estateType: attribute(key: "pre_qualification/estate_type") {
            estateType {
              value
            }
          }
          estateUsage: attribute(key: "pre_qualification/estate_usage") {
            estateUsage {
              value
            }
          }
          user_intention: attribute(key: "pre_qualification/user_intention") {
            userIntention {
              value
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
